
import { Component, Vue } from 'vue-property-decorator'
import { RequestPaging } from '@/utils/util'
import { apiAuthPlatformRuleLists, apiAuthPlatformRuleDel } from '@/api/permissions'
import LsPagination from '@/components/ls-pagination.vue'
import LsDialog from '@/components/ls-dialog.vue'
import { PageMode } from '@/utils/type'
import { MenuEnum } from '@/utils/appEnums'

@Component({
    components: {
        LsDialog,
        LsPagination
    }
})
export default class Role extends Vue {
    $refs!: { plTreeTable: any }
    /** S Data **/
    pager: RequestPaging = new RequestPaging()
    MenuEnum = MenuEnum
    isExpand = false
    lists: any = []
    expandRowKeys: any = []
    is_refresh = true
    isAllExpanded = false
    /** E Data **/

    /** S Methods **/
    // 展开折叠

    // handleExpand() {
    //     this.isExpand = !this.isExpand
    //     if (this.isExpand) {
    //         this.$refs.plTreeTable.setAllTreeExpansion()
    //     } else {
    //         this.$refs.plTreeTable.clearTreeExpand()
    //     }
    // }

    // 添加角色
    onRoleAdd(item: any): void {
        this.$router.push({
            path: '/setting/permissions/menus_edit',
            query: {
                mode: PageMode.ADD,
                id: item.id
            }
        })
    }

    // 编辑角色
    onRoleEdit(item: any): void {
        this.$router.push({
            path: '/setting/permissions/menus_edit',
            query: { mode: PageMode.EDIT, id: item.id }
        })
    }

    // 删除角色
    onRoleDel(data: any): void {
        apiAuthPlatformRuleDel({
            id: data.id
        })
            .then(() => {
                this.getRoleList()
                this.$message.success('删除成功')
            })
            .catch(() => {
                this.$message.error('删除失败')
            })
    }

    // 获取数据
    getRoleList(): void {
        this.pager
            .request({
                callback: apiAuthPlatformRuleLists,
                params: {
                    pid: 58
                }
            })
            .then(res => {
                this.handleSetExpandedKeys(res.lists)
                this.is_refresh = false
            })
            .catch(() => {
                
            })
    }
    // 递归设置展开行
    handleSetExpandedKeys(lists: any[]): void {
        if (!lists || !Array.isArray(lists)) return

        for (const row of lists) {
            if (this.expandRowKeys.includes(row.id)) {
                this.$refs.plTreeTable?.toggleRowExpansion(row, true)
            }
            if (row.children && Array.isArray(row.children) && row.children.length > 0) {
                this.handleSetExpandedKeys(row.children)
            }
        }
    }
    handleToggleRowExpansion(row: any, rowIndex: number) {
        if (this.is_refresh) return
        if (this.expandRowKeys.indexOf(row.id) !== -1) {
            this.expandRowKeys.splice(this.expandRowKeys.indexOf(row.id), 1)
        } else {
            this.expandRowKeys.push(row.id)
        }
        localStorage.setItem('expandRowKeys', JSON.stringify(this.expandRowKeys))
    }
    toggleExpandAll() {
        this.isAllExpanded = !this.isAllExpanded
        this.toggleAllRows(this.isAllExpanded)
    }
    toggleAllRows(expand: any) {
        // 递归遍历所有行
        const traverse = (data: any) => {
            data.forEach((row: any) => {
                this.$refs.plTreeTable?.toggleRowExpansion(row, expand)
                if (row.children && row.children.length) {
                    traverse(row.children)
                }
            })
        }
        traverse(this.pager.lists)
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.getRoleList()
    }
    mounted() {
        const expandRowKeys = localStorage.getItem('expandRowKeys')
        if (expandRowKeys) {
            this.expandRowKeys = JSON.parse(expandRowKeys)
        }
    }
    /** E Life Cycle **/
}
